import PhoneDirectory from "../applications/PhoneDirectory/PhoneDirectory";
import {ContextProvider } from "../applications/PhoneDirectory/context/PhoneDirectoryContext";

const PhoneDirectoryMain = () => {
  return (
    <>
      <ContextProvider>
         <PhoneDirectory />
      </ContextProvider>
    </>
  );
};
export default PhoneDirectoryMain;
